import { action, observable } from 'mobx'
import { createContext } from 'react'

import { DEFAULT_FILTERS, DEFAULT_RESOLVED_DATE_FILTERS } from '../pages/DealerDetails/constants'

import { BaseStore } from './BaseStore'

const INITIAL_STATE = {
  currentDealerId: null,
  outstandingFilters: DEFAULT_FILTERS,
  resolvedFilters: DEFAULT_FILTERS,
  resolvedDateFilters: DEFAULT_RESOLVED_DATE_FILTERS,
  adminSortedColumn: 'ro_number',
  adminCurrentPage: 1,
  adminPerPage: 20,
  dealerSortedColumn: 'ro_number',
  dealerCurrentPage: 1,
  dealerPerPage: 20,
  resolvedSortedColumn: '-resolved_at',
  resolvedCurrentPage: 1,
  resolvedPerPage: 20,
}

const TYPES = {
  currentDealerId: observable,
  outstandingFilters: observable,
  resolvedFilters: observable,
  resolvedDateFilters: observable,
  adminSortedColumn: observable,
  adminCurrentPage: observable,
  adminPerPage: observable,
  dealerSortedColumn: observable,
  dealerCurrentPage: observable,
  dealerPerPage: observable,
  resolvedSortedColumn: observable,
  resolvedCurrentPage: observable,
  resolvedPerPage: observable,
}

export class DealerFilterStore extends BaseStore {
  setDealerContext = action((id) => {
    this.currentDealerId = id
  })

  setOutstandingFilters = action((filters) => {
    this.outstandingFilters = filters
  })

  setResolvedFilters = action((filters) => {
    this.resolvedFilters = filters
  })

  setResolvedDateFilters = action((filters) => {
    this.resolvedDateFilters = filters
  })

  setAdminSortedColumn = action((column) => {
    this.adminSortedColumn = column
  })

  setAdminCurrentPage = action((page) => {
    this.adminCurrentPage = page
  })

  setAdminPerPage = action((perPage) => {
    this.adminPerPage = perPage
  })

  setDealerSortedColumn = action((column) => {
    this.dealerSortedColumn = column
  })

  setDealerCurrentPage = action((page) => {
    this.dealerCurrentPage = page
  })

  setDealerPerPage = action((perPage) => {
    this.dealerPerPage = perPage
  })

  setResolvedSortedColumn = action((column) => {
    this.resolvedSortedColumn = column
  })

  setResolvedCurrentPage = action((page) => {
    this.resolvedCurrentPage = page
  })

  setResolvedPerPage = action((perPage) => {
    this.resolvedPerPage = perPage
  })

  clearContext = action(() => {
    this.currentDealerId = null
    this.outstandingFilters = DEFAULT_FILTERS
    this.resolvedFilters = DEFAULT_FILTERS
    this.resolvedDateFilters = DEFAULT_RESOLVED_DATE_FILTERS
    this.adminSortedColumn = 'ro_number'
    this.adminCurrentPage = 1
    this.adminPerPage = 20
    this.dealerSortedColumn = 'ro_number'
    this.dealerCurrentPage = 1
    this.dealerPerPage = 20
    this.resolvedSortedColumn = '-resolved_at'
    this.resolvedCurrentPage = 1
    this.resolvedPerPage = 20
  })
}

export const dealerFilter = new DealerFilterStore(INITIAL_STATE, TYPES)
export const DealerFilterStoreContext = createContext(dealerFilter)
